import axios from "axios";
import { showError } from "../../components/ModernSnackbar";
import Cookies from 'js-cookie';

const BASE_URL = process.env.REACT_APP_SERVICE_BASE_URL; // Default to localhost if env is missing

// Helper to get token from cookies
const getAuthToken = () => Cookies.get('fytn_token');


export default async function submitTestAPI(
  name,
  age,
  course,
  email,
  phone,
  selectedOption,
  collegeName,
  grade,
  section,
  schoolName,
  companyName,
  role,
  edu,
  formattedData
) {
  try {
  
    const requestData = {
      name: name,
      age: age,
      user_email: email,
      user_phone: phone,
      user_type: selectedOption,
      student_details: {
        institution_name: schoolName || collegeName || null,
        grade: grade || null,
        section: section || null,
        course: course || null,
      },
      professional_details: {
        company_name: companyName || null,
        role: role || null,
        highest_education: edu || null,
      },
      response: {
        value: formattedData?.value || 0,
        interest: formattedData?.interest || "Unknown",
        personality: formattedData?.personality || "Unknown",
      },
    };



    const response = await axios.post(
      `${BASE_URL}/api/add-user`,
      requestData,
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: false, // Explicitly disable sending cookies
      }
    );

    return response;
  } catch (error) {
    if (error.response) {
      console.error("Error Response Data:", error.response.data);
      console.error("Error Response Status:", error.response.status);
    } else if (error.request) {
      console.error("No Response Received:", error.request);
    } else {
      console.error("Error Message:", error.message);
    }
    throw error;
  }
}
export const getAllUsers = async (master_id) => {
  try {
    const token = getAuthToken();
    const res = await axios.get(`${BASE_URL}/api/all-users`, {
      params: { master_id },
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
   
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getAllAdminUsers = async () => {
      const token = getAuthToken();
  try {
    const response = await axios.get(`${BASE_URL}/api/admin/all-users`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    console.log("Response:", response);
    return response;
  } catch (err) {
    console.log("unable to get the all users");
  }
};
export const AddLicence = async ({ USER_AUTH_ID, licenses_to_add }) => {

   const token = getAuthToken();
  try {
    const response = await axios.put(
      `${BASE_URL}/api/admin/add-licence`,

      {
        USER_AUTH_ID: USER_AUTH_ID,
        licenses_to_add: licenses_to_add,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (err) {
    console.log("Unable to add the license", err);
  }
};

export const deleteAdmin = async (id) => {
  try {
    const token = getAuthToken();
    const res = await axios.delete(`${BASE_URL}/api/admin/delete-users`, {
      data: {
        user_ids: [id],
      },
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return res.data; 
  } catch (error) {
    throw error;
  }
};

export const AddAdminUsers = async (data) => {
  try {
    const token = getAuthToken();
    const res = await axios.post(
      `${BASE_URL}/api/admin/add-users`,
      data,
      {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      }
    );
    return res;
  } catch (error) {
    throw error;
  }
};

// New API for adding users to user_master table
export const AddSingleUser = async (data) => {
  try {
    const token = getAuthToken();
    const res = await axios.post(
      `${BASE_URL}/api/admin/add-single-user`,
      data,
      {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      }
    );
    return res;
  } catch (error) {
    throw error;
  }
};

export const EditAdminUsers = async (data) => {
  try {
    const token = getAuthToken();
    const res = await axios.put(
      `${BASE_URL}/api/admin/edit-users`,
      data,
      {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      }
    );
    return res;
  } catch (error) {
    throw error;
  }
};



export const generateLink = async (userId, master_id) => {
  try {
    const token = getAuthToken();
    const res = await axios.post(`${BASE_URL}/api/generate-test-link`, {
      userId,
      master_id,
    }, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const generateReport = async (userId, master_id, type, setDownloadModalOpen) => {
  const data = {
    user_id: userId,
    user_auth_master_id: master_id,
    regenerate_response: type === "regenerate", 
  };

  

  try {
    const token = getAuthToken();
    const res = await axios.post(`${BASE_URL}/api/generate`, data, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    console.log("res", res);
    return res.data;
  } catch (error) {
    showError("Unable to get the report");
    setDownloadModalOpen(false);
    throw error;
  }
};

export const verifyLink = async (token) => {
  try {
    const res = await axios.get(`${BASE_URL}/api/verify-token/${token}`);
    return res;
  } catch (error) {
    throw error;
  }
};

export const upload = async (data, userId) => {
  try {
    const token = getAuthToken();
    const formData = new FormData();
    formData.append("file", data);
    formData.append("master_id", userId);

    const res = await axios.post(
      `${BASE_URL}/api/user-master/upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      }
    );

    return res;
  } catch (error) {
    throw error;
  }
};

export const signup = async (data) => {
  return axios.post(`${BASE_URL}/api/auth/signup`, data);
};

export const login = async (data) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/auth/login`, data);
    console.log("Login Response:", response);
     return response.data;
  } catch (error) {
    console.log("Login Error:", error);
    showError(error.response?.data?.message);
  } 
 
};

export const submitTestAPINew = async (user_id, master_id, formattedData) => {
  try {
    const requestData = {
      user_id,
      master_id,
      response: {
        value: formattedData?.value || 0,
        interest: formattedData?.interest || "Unknown",
        personality: formattedData?.personality || "Unknown",
      },
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    // Add Authorization header if token exists
    // const token = getAuthToken();
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`;
    // }

    const response = await axios.post(
      `${BASE_URL}/api/submit-test`,
      requestData,
      // config
    );

    return response;
  } catch (error) {
    if (error.response) {
      console.error("Error Response Data:", error.response.data);
      console.error("Error Response Status:", error.response.status);
    } else if (error.request) {
      console.error("No Response Received:", error.request);
    } else {
      console.error("Error Message:", error.message);
    }
    throw error;
  }
};

export const deleteUser = async (adminId, userIdArray) => {
  const data = { adminId: adminId, userIds: userIdArray };
  console.log("DELETE", data)
  try {
    const token = getAuthToken();
    const response = await axios.delete(`${BASE_URL}/api/users/delete`, {
      data: data,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return response;
  } catch (error) {
    console.error("Error deleting user(s):", error);
    throw error;
  }
};

export const forgotPassword = async (email) => {
 try {
  const res= await axios.post(`${BASE_URL}/api/auth/forgot-password`, { email }, {
    headers: { "Content-Type": "application/json" },
  });
   return res
 } catch (error) {
  console.error("Error in forgotPassword:", error);
 }
 
 
};

export const resetPassword = async (token, password) => {
  try {
    const res = await axios.post(
      `${BASE_URL}/api/auth/reset-password`,
      { token, new_password:password },
      { headers: { "Content-Type": "application/json" } }
    );
    return res;
  } catch (error) {
    console.error("Error in resetPassword:", error);
    throw error;
  }
};

// Email Configuration APIs
export const testEmailConfig = async (userId, smtpConfig) => {
  try {
    const token = getAuthToken();
    const response = await axios.post(`${BASE_URL}/api/test-email-config`, {
      userId,
      smtp: smtpConfig
    }, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error testing email config:", error);
    throw error;
  }
};

export const saveEmailConfig = async (userId, smtpConfig) => {
  try {
    const token = getAuthToken();
    const response = await axios.post(`${BASE_URL}/api/save-email-config`, {
      userId,
      smtp: smtpConfig
    }, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error saving email config:", error);
    throw error;
  }
};

export const getEmailConfig = async (userId) => {
  try {
    const token = getAuthToken();
    const response = await axios.get(`${BASE_URL}/api/email-config/${userId}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error getting email config:", error);
    throw error;
  }
};

export const sendEmail = async (userId, emailData) => {
  try {
    const token = getAuthToken();
    const response = await axios.post(`${BASE_URL}/api/send-email`, {
      userId,
      ...emailData
    }, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error sending email:", error);
    throw error;
  }
};
